import React, { Component } from 'react';
import { ReactQueryConfigProvider } from 'react-query';
import validate from 'validate.js';
import { Chart } from 'react-chartjs-2';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@material-ui/styles';
import 'chartjs-plugin-datalabels';
import theme from './theme';
import Routes from './Routes';
import { chartjs } from './helpers';
import validators from './common/validators';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import 'cropperjs/dist/cropper.css';

export const browserHistory = createBrowserHistory();

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw,
});

validate.validators = {
  ...validate.validators,
  ...validators,
};

export default class App extends Component {
  render() {
    return (
      <ReactQueryConfigProvider
        config={{ queries: { refetchOnWindowFocus: false, staleTime: 60000 } }}
      >
        <ThemeProvider theme={theme}>
          <Router history={browserHistory}>
            <Routes />
          </Router>
        </ThemeProvider>
      </ReactQueryConfigProvider>
    );
  }
}
